<template>
  <div v-if="passwordUpdated">
    <p>{{ $t('account.password-update.success') }}</p>
    <base-button @click="goLogin">{{ $t('account.password-update.click-login')}}</base-button>
  </div>
  <b-form @submit.stop.prevent="updatePassword" v-else>
    <b-alert show variant="danger" v-if="form.state.submitted && form.state.errors" v-html="submitError"></b-alert>
    <p>{{ $t('account.password-update.security-requirements') }}</p>
    <b-form-group>
      <base-input v-model="$v.form.password.$model" :state="validateState('password')" :validator="$v.form.password" :placeholder="$t('account.password-update.password')" :type="showPassword ? 'text' : 'password'">
        <template slot="append">
          <span @click="showPassword = !showPassword" class="clickable">
            <i><b-icon-eye v-if="!showPassword"></b-icon-eye><b-icon-eye-slash v-else></b-icon-eye-slash></i>
          </span>
        </template>
      </base-input>
      <base-input v-model="$v.form.confirmedPassword.$model" :state="validateState('confirmedPassword')" :validator="$v.form.confirmedPassword" :placeholder="$t('account.password-update.repeat-password')" :type="showPassword ? 'text' : 'password'">
        <template slot="append">
          <span @click="showPassword = !showPassword" class="clickable">
            <i><b-icon-eye v-if="!showPassword"></b-icon-eye><b-icon-eye-slash v-else></b-icon-eye-slash></i>
          </span>
        </template>  
      </base-input>
    </b-form-group>
    <b-button type="submit" variant="primary" style="width: 100%">
      {{ $t('account.password-update.update-password') }}
    </b-button>
    <hr>
  </b-form>
</template>

<script>
import { BForm, BAlert, BFormGroup, BButton, BIconEyeSlash, BIconEye } from 'bootstrap-vue'
import accountRepository from '@/repositories/AccountRepository'
import { password } from '@/plugins/customValidators'
import { validationsMixin } from '@/mixins/validations.mixin'
import { required, sameAs } from 'vuelidate/lib/validators'
import accountMixin from '@/mixins/account.mixin'

export default {
  mixins: [validationsMixin, accountMixin],
  components: {
    BForm, BAlert, BFormGroup, BButton, BIconEyeSlash, BIconEye
  },
  data () {
    return {
      submitError: null,
      passwordUpdated: false,
      form: {
        state: {
          submitted: false,
          errors: false
        },
        password: null,
        confirmedPassword: null
      },
      pwdToken: null,
      showPassword: false
    }
  },
  validations: {
    form: {
      password: password,
      confirmedPassword: {
        required,
        sameAsPassword: sameAs('password')
      }
    }
  },
  methods: {
    updatePassword () {
      if (this.formIsValid()) {
        this.form.state.submitted = true
        accountRepository.updatePassword(this.form.password, this.pwdToken).then((response) => {
          if (response && !response.response) {
            this.passwordUpdated = true
          } else {
            this.form.state.errors = true
            switch (response.response.status) {
              case 401:
                this.submitError = this.$t('account.password-update.error')
                break
              case 500:
                this.submitError = this.$t('account.password-update.error-requisites')
                break
              default:
                this.submitError = this.$t('account.password-update.error-requisites')
                break
            }
          }
        }).catch((error) => {
          this.form.state.errors = true
          if (error.response.status === 401) {
            this.submitError = this.$t('account.password-update.error')
          } else {
            this.submitError = this.$t('account.password-update.error-requisites')
          }
        })
      }
    }
  },
  mounted () {
    const pwdToken = this.$route.query.t
    if (!pwdToken) {
      this.$router.push('/unauthorized')
    } else {
      this.pwdToken = pwdToken
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/account/PasswordUpdate.vue